import { render, staticRenderFns } from "./SingleOptionDropdown.vue?vue&type=template&id=19da9835&scoped=true"
import script from "./SingleOptionDropdown.vue?vue&type=script&lang=js"
export * from "./SingleOptionDropdown.vue?vue&type=script&lang=js"
import style0 from "./SingleOptionDropdown.vue?vue&type=style&index=0&id=19da9835&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19da9835",
  null
  
)

export default component.exports